import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { LanguageEvaluationSpeaking } = await import('./index');
    return {
        Component: LanguageEvaluationSpeaking,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
